<template>
  <div class="form-is-success" v-if="isFormSent">
    <h3 class="form-is-success__title">Ваш запрос отправлен</h3>
    <p class="form-is-success__dsc">Мы&nbsp;свяжемся с&nbsp;вами в&nbsp;случае возникновения интереса</p>
  </div>
  <div v-else>
    <form method="post" @submit.prevent="onSubmit" novalidate>
      <form-field>
        <label for="company">Название вашей компании</label>
        <base-input ref="company" id="company" name="company" v-model="form.company" />
      </form-field>

      <form-field>
        <label for="site">Ваш сайт</label>
        <base-input ref="site" id="site" name="site" v-model="form.site" />
      </form-field>

      <form-field :error="emailError">
        <label for="email">Ваша эл. почта для связи</label>
        <base-input
          id="email"
          ref="email"
          name="email"
          required
          type="email"
          v-model="form.email"
          :invalid="emailInvalid"
          @change="updateEmailValidity"
        />
      </form-field>

      <form-field>
        <label for="partnership_huntflow_move"
          >Что вы&nbsp;хотите, чтобы Хантфлоу сделал в&nbsp;рамках партнерства или
          <span class="nowrap">кросс-промо</span></label
        >
        <base-textarea
          id="partnership_huntflow_move"
          class="baseTextarea"
          ref="partnership_huntflow_move"
          name="partnership_huntflow_move"
          v-model="form.partnership_huntflow_move"
        />
      </form-field>

      <form-field>
        <label for="partnership_your_move">Что вы&nbsp;сделаете в&nbsp;ответ</label>
        <base-textarea
          id="partnership_your_move"
          class="baseTextarea"
          ref="partnership_your_move"
          name="partnership_your_move"
          v-model="form.partnership_your_move"
        />
      </form-field>

      <form-field>
        <label for="audience_parameters">Опишите параметры вашей аудитории: объем, метрики, соцдем</label>
        <base-textarea
          id="audience_parameters"
          class="baseTextarea"
          ref="audience_parameters"
          name="audience_parameters"
          v-model="form.audience_parameters"
        />
      </form-field>

      <form-field>
        <label for="partnership_huntflow_benefit"
          >Почему Хантфлоу будет выгодно это партнерство или <span class="nowrap">кросс-промо</span></label
        >
        <base-textarea
          id="partnership_huntflow_benefit"
          class="baseTextarea"
          ref="partnership_huntflow_benefit"
          name="partnership_huntflow_benefit"
          v-model="form.partnership_huntflow_benefit"
        />
      </form-field>

      <base-button type="submit" :class="[{ baseButtonDisabled: !formFilled }, 'baseButton']"
        >Отправить в отдел маркетинга</base-button
      >

      <p class="privacy-policy">
        Отправляя форму, я&nbsp;даю согласие на&nbsp;обработку персональных данных в&nbsp;соответствии с&nbsp;<a
          href="/docs/privacy-policy"
          target="_blank"
          >политикой конфиденциальности</a
        >
        ООО «Хантфлоу».
      </p>
    </form>
  </div>
</template>

<script>
import 'huntkit/hunt-kit.css';
import { BaseButton, BaseInput, BaseTextarea, FormField } from 'huntkit';

export default {
  components: {
    BaseButton,
    BaseInput,
    BaseTextarea,
    FormField,
  },
  data: function () {
    return {
      form: {
        company: '',
        site: '',
        email: '',
        partnership_huntflow_move: '',
        partnership_your_move: '',
        audience_parameters: '',
        partnership_huntflow_benefit: '',
      },
      emailError: '',
      emailInvalid: false,
      isEmptyFieldExist: true,
      isFormSent: false,
    };
  },
  methods: {
    updateEmailValidity(e) {
      this.emailError = e.target.validity.valid ? '' : 'Некорректная почта';
      if (e.target.value.length === 0) {
        this.emailError = 'Введите адрес эл. почты';
      }
      this.emailInvalid = !e.target.validity.valid;
    },
    findEmptyField() {
      let emptyFieldName = '';
      this.isEmptyFieldExist = false;

      for (let key in this.form) {
        if (!this.form[key]) {
          emptyFieldName = key;
          this.isEmptyFieldExist = true;
          break;
        }
      }

      if (emptyFieldName && !this.emailInvalid) {
        this.$refs[`${emptyFieldName}`].$el.focus();
      }

      if (this.emailInvalid) {
        this.$refs['email'].$el.focus();
      }

      return this.isEmptyFieldExist;
    },
    onSubmit(e) {
      if (!this.findEmptyField()) {
        const formWrap = document.querySelector('.form-wrapper');
        const rect = formWrap.getBoundingClientRect();
        const y = rect.top + window.pageYOffset - 150;

        return fetch('/to-marketing-partnership', {
          method: 'post',
          body: JSON.stringify(this.form),
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
          .then((r) => r.json().then((json) => [r.status, json]))
          .then(([status, json]) => {
            if (status === 200) {
              window.scrollTo(0, y);
              this.isFormSent = true;
            }
            return json;
          })
          .catch((err) => {
            return Promise.reject('Что-то пошло не так. Попробуйте ещё раз.');
          });
      }
    },
  },
  computed: {
    formFilled() {
      return Object.values(this.form).every((value) => value) && !this.emailInvalid;
    },
  },
};
</script>

<style lang="scss">
@use '~styles/core/_variables.scss' as vars;
@use '~styles/core/_mixins.scss' as mixins;

label {
  @include mixins.font(16px, 18px);

  font-family: 'hunt-kit-graphik', Arial, Helvetica, sans-serif;
  font-weight: 400;
}

.baseButton {
  width: 100%;
  margin-top: 3.2rem;
}
.baseButtonDisabled {
  background-color: #2f2f31;
  color: #9c9c9c;
  cursor: default;
}

.baseTextarea {
  resize: none;
  height: 160px;
}

.markdown .privacy-policy {
  @include mixins.font(1.6rem, 1.5);
  margin-top: 1.6rem;

  @include mixins.media(md) {
    @include mixins.font(1.6rem, 1.5);
    margin-top: 2rem;
  }

  a {
    color: #b2b3ad;
    text-decoration: underline;
  }
}
</style>
